import type { $Fetch } from 'ofetch';
import type { Frequencia, LancarFrequenciaCommand } from '@/domain/model/Frequencia';
import type { FrequenciaGateway } from '@/application/port/out/FrequenciaGateway';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** FASE C.4 — gateway HTTP /api/v1/matriculas/{id}/frequencias (enrollment slice). */
export class HttpFrequenciaGateway implements FrequenciaGateway {
  constructor(private readonly client: $Fetch) {}

  async listByMatricula(matriculaId: string): Promise<Frequencia[]> {
    const res = await this.client<ApiResponse<Frequencia[]>>(
      `/api/v1/matriculas/${encodeURIComponent(matriculaId)}/frequencias`,
      { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async lancar(command: LancarFrequenciaCommand): Promise<Frequencia> {
    const res = await this.client<ApiResponse<Frequencia>>(
      `/api/v1/matriculas/${encodeURIComponent(command.matriculaId)}/frequencias`,
      {
        method: 'POST',
        body: {
          disciplineId: command.disciplineId,
          mes: command.mes,
          ano: command.ano,
          totalAulas: command.totalAulas,
          aulasPresentes: command.aulasPresentes,
        },
      },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
